<template>
    <div>
      <CRow>
        <CCol>
          <CCard class="tarjetaCV mt-2">
            <CCardHeader>
              <h4>Información Clientes Vapp</h4>
            </CCardHeader>
            <CCardBody>
                <CTabs :active-tab.sync="actTab">
                    <CTab>
                        <template slot="title">
                            Clientes Vapp(AD)
                        </template>
                        <ClientesVapp />
                    </CTab>
                    
                    <CTab>
                        <template slot="title">
                            Documentos Mail
                        </template>

                        <DocumentosMail />
                        
                    </CTab>
                </CTabs>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  </template>
  
  
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  
  <script>
  import Vue from 'vue'
  import cons from "@/const";
  import axios from "axios";
  
  
  import Multiselect from "vue-multiselect";
  
  import VueModal from "@kouts/vue-modal";
  import "@kouts/vue-modal/dist/vue-modal.css";
  
  import { freeSet } from "@coreui/icons";
  
  //import moment from 'moment'
  import { format, formatDistance, formatRelative, subDays } from "date-fns";
  import es from "date-fns/locale/es";
  window.locale = "es";
  
  //import DatePicker from 'vue2-datepicker';
  //import 'vue2-datepicker/index.css';
  
  import Pagination from 'vue-pagination-2';
  
  //import clienteInfo from "./componentes/ClienteInfoComponente";
  //import InfoGeneral from "./componentes/InfoGeneralComponente";
  
  import ClientesVapp from "./SeccionesInternas/ClientesVapp";
  
  import DocumentosMail from "./SeccionesInternas/DocumentosMail";
  
  export default {
    name: "ClientesB2B",
    freeSet,
    components: {
      Multiselect,
      Modal: VueModal,
      //clienteInfo,
      //InfoGeneral,
      Pagination,
      ClientesVapp,
      DocumentosMail
    },
    data() {
      return {
        filtroGeneralCliente: "",
        page: 1,
        max: 5,
  
        baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,
  
        tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,
        
        
        actTab: 0,
        
  
      };
    },
    created: function () {},
    beforeMount() {

    },
    mounted() {},
    methods: {
      
      
    },
  };
  </script>
  
  <style>
  </style>